import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/videos/CFB-02C.mp4")